import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';
import { observable, computed } from 'mobx';
import { observer } from 'mobx-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { DialogService } from "src/core/services/ui/dialog.service";
import { ControllerProps } from 'src/router';
import { ObjectUtils } from 'src/core/utils/object';
import { ConfigurationService } from 'src/core/services/configuration.service';
import { CustomTemplateFormView } from './custom-template-form.view'

interface CustomTemplateFormParams extends ComponentViewProps<ICustomTemplateItem> {
    mode: ControlMode;
    fileChanged: (file: File) => void;
    templateName: string;
    showUserCombo: boolean;
}

export class CustomTemplateFormController extends React.Component<CustomTemplateFormParams, any> {
    render() {
        return (
            <CustomTemplateFormView
                {...this.props}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/general/document-templates/form/parts/custom-template-form.controller.tsx